import React from "react"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import TitleBar from "../../components/TitleBar/TitleBar"
import {ApplicationForms, ApplicationFormsColumns} from "../../components/ApplicationForms/ApplicationForms"
import {useIsUnitUser} from "../../services/auth"
import {useRefreshToken} from "../../hooks/useRefreshToken"

export default function ApplicationFormsPage() {
	const [refreshToken] = useRefreshToken()
	const isUnitUser = useIsUnitUser()

	if (!isUnitUser) {
		return null
	}

	return (
		<>
			<TitleBar title={"Application Forms"} className={"title-bar-no-border"} />

			<MainSectionTable>
				<ApplicationForms
					refreshToken={refreshToken}
					includedColumns={[
						ApplicationFormsColumns.id,
						ApplicationFormsColumns.org,
						ApplicationFormsColumns.createdAt,
						ApplicationFormsColumns.updatedAt,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
